const angular = require('angular')

angular.module('ui.hxphone.onerror', [])
/* .directive('focusMe', function($timeout, $parse) {
        return {
            link: function(scope, element) {
                $timeout(function() {
                    element[0].focus();
                }, 0);
            }
        }
    }) */
  .directive('ngError', ['$parse', function($parse) {
    return {
      restrict: 'A',
      compile: function($element, attr) {
        const fn = $parse(attr['ngError'])
        return function(scope, element, attr) {
          element.on('error', function(event) {
            scope.$apply(function() {
              fn(scope, {$event: event})
            })
          })
        }
      }
    }
  }])



// WEBPACK FOOTER //
// ./src/js/infrastructure/onerror.js